import { createFileRoute } from '@tanstack/react-router';
import {
  tenantRequestDetailScreen,
  tenantRequestDetailSearch,
  loadTenantRequestMessages,
  loadTenantRequestScreens,
} from '@/modules/tenant-request/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/parceiros/solicitacoes/$id/')({
  validateSearch: tenantRequestDetailSearch,
  staticData: { screen: tenantRequestDetailScreen },
  loader: loadTenantRequestMessages,
  component: lazyScreen(loadTenantRequestScreens, 'TenantRequestFormPage'),
});
